// Base URL for the Mashwara Django backend.
// Override per-environment with REACT_APP_API_BASE_URL (e.g. in a .env file).
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
